import { AgentTransport } from "./rpc";

/** Key an @observable pydantic model's dump is tagged with (see
 * common._ObservableMixin._serialize_with_tag), naming which generated Store
 * class the value came from. Never declared as a field on any model --
 * injected at dump time, and stripped back out of any field whose static
 * type is opaque (e.g. RPC tool arguments) so caller-defined data can never
 * spoof it -- see common._contains_any/_strip_entity_tag. */
export const ENTITY_TAG_KEY = "_entity_class_name";

type EntityCtor = new (data: any, transport: AgentTransport, chainPath: string[]) => any;

// Populated by every generated `*.generated.ts` module as a side effect of
// being imported (see registerEntity calls at the bottom of each file) --
// importing the barrel (index.ts) is enough to fully populate this.
const registry: Record<string, EntityCtor> = {};

export function registerEntity(tag: string, ctor: EntityCtor): void {
    registry[tag] = ctor;
}

/** Turns a plain JSON value into its generated Store instance wherever it
 * carries a recognized ENTITY_TAG_KEY, recursing into arrays -- otherwise
 * (scalars, opaque data, unrecognized tags) returns it unchanged. This is
 * the single mechanism the whole `app_store/agent` layer uses to decide both
 * "does this need to become a Store" and "which one" -- including union-typed
 * fields like AgentSessionData.container, since the concrete class is read
 * off the value itself rather than a static field declaration. */
export function wrapEntity(value: any, transport: AgentTransport, chainPath: string[]): any {
    if (Array.isArray(value)) {
        return value.map((item, idx) => wrapEntity(item, transport, [...chainPath, String(idx)]));
    }
    if (value !== null && typeof value === "object") {
        const tag = (value as Record<string, unknown>)[ENTITY_TAG_KEY];
        const ctor = typeof tag === "string" ? registry[tag] : undefined;
        if (ctor) {
            return new ctor(value, transport, chainPath);
        }
    }
    return value;
}
